var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOracleProfilesDuplicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 16,
      height: 16
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.3125C0.5 5.42383 1.21094 4.6875 2.125 4.6875H3.75V7.9375C3.75 9.2832 4.81641 10.375 6.1875 10.375H9.4375V12C9.4375 12.9141 8.70117 13.625 7.8125 13.625H2.125C1.21094 13.625 0.5 12.9141 0.5 12V6.3125ZM6.1875 9.5625C5.27344 9.5625 4.5625 8.85156 4.5625 7.9375V2.25C4.5625 1.36133 5.27344 0.625 6.1875 0.625H11.875C12.7637 0.625 13.5 1.36133 13.5 2.25V7.9375C13.5 8.85156 12.7637 9.5625 11.875 9.5625H6.1875Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracleProfilesDuplicate);
export default __webpack_public_path__ + "static/media/oracle-profiles-duplicate.75d0705a071e7fbf2c09005f583e1bd1.svg";
export { ForwardRef as ReactComponent };